__webpack_require__.p = "/assets/turbo/47c1291e/quellede/_next/";